import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { AppStore } from "stores";
import { organizationUrl } from "core/utils";

const GlobalKeyboardShortcuts = observer(() => {
  const [keySequence, setKeySequence] = useState<string[]>([]);
  const history = useHistory();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Ignore if user is typing in an input/textarea
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
        return;
      }

      // Handle key sequences first (like 'g,t' and 'g,d')
      if (keySequence[0] === 'g') {
        if (e.key === 't') {
          e.preventDefault();
          history.push(organizationUrl("test-runs"));
          setKeySequence([]);
          return;
        } else if (e.key === 'd') {
          e.preventDefault();
          history.push(organizationUrl("dashboard"));
          setKeySequence([]);
          return;
        } else {
          setKeySequence([]);
        }
      }

      // Start a key sequence with 'g'
      if (e.key === 'g') {
        e.preventDefault();
        setKeySequence(['g']);
        setTimeout(() => setKeySequence([]), 2000); // Clear after 2 seconds
        return;
      }

      // Handle single-key shortcuts (only when not in a sequence)
      if (e.key === 'm') {
        e.preventDefault();
        AppStore.setLeftNavCollapsed(!AppStore.isLeftNavCollapsed);
        return;
      }

      if (e.key === 'd') {
        e.preventDefault();
        AppStore.toggleDarkMode();
        return;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [keySequence, history]);

  return null;
});

export default GlobalKeyboardShortcuts;
